import { capitalize } from 'vue';

import rootState from '@/store/state';

import Permission, { actions, entities } from './Permission';

export interface IPermissions {
  [key: string]: boolean;
  canWritePlan?: boolean;
  canReadAvails?: boolean;
  canWriteCampaign?: boolean;
  canWritePackage?: boolean;
  canWriteCuratedpackage?: boolean;
}

export default class Permissions {
  permissions: Permission[];

  constructor(permissions: Permission[]) {
    this.permissions = permissions;
    this.generatePermissions();
  }

  private generatePermissions(): IPermissions {
    const generatedPermissions: IPermissions = {};
    Object.entries(actions).forEach(([actionName, action]) => {
      Object.entries(entities).forEach(([entityName, entity]) => {
        const propertyName = `can${capitalize(actionName.toLowerCase())}${capitalize(entityName.toLowerCase())}`;
        this[propertyName] = rootState.debugMode || !!this.hasPermission(action, entity);
      });
    });
    return generatedPermissions;
  }

  static fromApi(apiList: string[][]): Permissions {
    const permissions = apiList.map((x) => Permission.fromApi(x)).filter((x) => !!x);
    return new Permissions(permissions);
  }

  toApi(): string[][] {
    return this.permissions.map((p) => p.toApi());
  }

  hasPermission(action: symbol, entity: symbol): boolean {
    return rootState.debugMode || this.permissions.some((p) => p.equals(new Permission(action, entity)));
  }
}
